import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/workerrole"

const serviceName = "WorkerRole-Service: ";
export default class WorkerRoleService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static postToAPI(role, successF, errorF) {
    WrapperService.post(API_URL, role, serviceName, successF, errorF)
  }

  static putToAPI(role, successF, errorF) {
    WrapperService.put(API_URL + "/" + role.id, role, serviceName, successF, errorF)
  }

  static deleteFromAPI(role, successF, errorF) {
    WrapperService.delete(API_URL + "/" + role.id, serviceName, successF, errorF)
  }

}
